import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";
import { SubjectCategoryMasterEndpoint, SubjectCategoryConfigMasterEndpoint } from "../../../Utility/Endpoints";

const SubjectCategoryConfigMaster = () => {
  const [configs, setConfigs] = useState([]);
  const [categories, setCategories] = useState([]); // for dropdown
  const [showModal, setShowModal] = useState(false);
  const [currentConfig, setCurrentConfig] = useState({
    subjectCategoryConfigID: 0,
    subjectCategoryID: 0,
    subjectCategoryConfigName: "",
    maxLimit: 0,
  });
  const [isEdit, setIsEdit] = useState(false);

  const apiUrl = SubjectCategoryConfigMasterEndpoint;

  useEffect(() => {
    fetchConfigs();
    fetchCategories();
  }, []);

  const fetchConfigs = async () => {
    try {
      const response = await axios.get(apiUrl);
      setConfigs(response.data);
    } catch (error) {
      toast.error("Failed to fetch configurations");
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(SubjectCategoryMasterEndpoint);
      setCategories(response.data);
    } catch (error) {
      toast.error("Failed to fetch subject categories");
    }
  };

  const handleShowModal = (
    config = {
      subjectCategoryConfigID: 0,
      subjectCategoryID: 0,
      subjectCategoryConfigName: "",
      maxLimit: 0,
    }
  ) => {
    setCurrentConfig(config);
    setIsEdit(config.subjectCategoryConfigID !== 0);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentConfig({
      subjectCategoryConfigID: 0,
      subjectCategoryID: 0,
      subjectCategoryConfigName: "",
      maxLimit: 0,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentConfig({ ...currentConfig, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        subjectCategoryConfigID: currentConfig.subjectCategoryConfigID,
        subjectCategoryID: parseInt(currentConfig.subjectCategoryID),
        subjectCategoryConfigName: currentConfig.subjectCategoryConfigName,
        maxLimit: parseInt(currentConfig.maxLimit),
      };

      if (isEdit) {
        await axios.put(`${apiUrl}/${currentConfig.subjectCategoryConfigID}`, payload);
        toast.success("Configuration updated successfully");
      } else {
        await axios.post(apiUrl, payload);
        toast.success("Configuration added successfully");
      }
      fetchConfigs();
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to save configuration");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this configuration?")) {
      try {
        await axios.delete(`${apiUrl}/${id}`);
        toast.success("Configuration deleted successfully");
        fetchConfigs();
      } catch (error) {
        toast.error("Failed to delete configuration");
      }
    }
  };

  const getCategoryName = (id) => {
    const category = categories.find((c) => c.subjectCategoryID === id);
    return category ? category.subjectCategoryName : "";
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Manage Subject Category Configurations</h3>
          <Button variant="primary" onClick={() => handleShowModal()}>
            Add Configuration
          </Button>
        </div>
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Category</th>
              <th>Config Name</th>
              <th>Max Limit</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {configs.map((config, index) => (
              <tr key={config.subjectCategoryConfigID}>
                <td>{index + 1}</td>
                <td>{getCategoryName(config.subjectCategoryID)}</td>
                <td>{config.subjectCategoryConfigName}</td>
                <td>{config.maxLimit}</td>
                <td>
                  <Button
                    variant="warning"
                    onClick={() => handleShowModal(config)}
                    className="me-2"
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() =>
                      handleDelete(config.subjectCategoryConfigID)
                    }
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Edit Configuration" : "Add Configuration"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Subject Category</Form.Label>
              <Form.Select
                name="subjectCategoryID"
                value={currentConfig.subjectCategoryID}
                onChange={handleChange}
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option
                    key={cat.subjectCategoryID}
                    value={cat.subjectCategoryID}
                  >
                    {cat.subjectCategoryName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Configuration Name</Form.Label>
              <Form.Control
                type="text"
                name="subjectCategoryConfigName"
                value={currentConfig.subjectCategoryConfigName}
                onChange={handleChange}
                placeholder="Enter configuration name"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Max Limit</Form.Label>
              <Form.Control
                type="number"
                name="maxLimit"
                value={currentConfig.maxLimit}
                onChange={handleChange}
                placeholder="Enter max limit"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            {isEdit ? "Update" : "Add"}
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default SubjectCategoryConfigMaster;
